export default __webpack_public_path__ + "static/media/cross.9cefd9b9.svg";